var _ellipse, _path, _path2, _g, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarshine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4120_17812)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4120_17812)",
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 45.5,
    rx: 7.5,
    ry: 19.5,
    fill: "url(#paint0_radial_4120_17812)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 23.25L46.5 44.856L69.75 23.25L48.144 46.5L69.75 69.75L46.5 48.144L23.25 69.75L44.856 46.5L23.25 23.25Z",
    fill: "url(#paint1_linear_4120_17812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5508 46.231L47.8672 47.251L46.8576 82.2959L45.8481 47.251L11.1645 46.231L45.8481 45.2109L46.8576 10.166L47.8672 45.2109L82.5508 46.231Z",
    fill: "url(#paint2_linear_4120_17812)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_diamond_4120_17812_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0301921 -0.0301921 0.0301921 0.0301921 45.5333 46.5581)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 715.937,
    height: 714.013,
    fill: "url(#paint3_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 715.937,
    height: 714.013,
    transform: "scale(1 -1)",
    fill: "url(#paint3_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 715.937,
    height: 714.013,
    transform: "scale(-1 1)",
    fill: "url(#paint3_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 715.937,
    height: 714.013,
    transform: "scale(-1)",
    fill: "url(#paint3_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.469 42.3754L46.5001 42.3996L46.5319 42.3748L67.2078 25.7923L50.6254 46.4682L50.6005 46.5L50.6254 46.5318L67.2078 67.2077L46.5319 50.6252L46.5001 50.6004L46.469 50.6246L25.7924 67.2077L42.3756 46.5311L42.3997 46.5L42.3756 46.4689L25.7924 25.7923L46.469 42.3754Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.96862745285034180,\"g\":0.69411766529083252,\"b\":0.17254902422428131,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.82745099067687988,\"b\":0.11372549086809158,\"a\":1.0},\"position\":0.80885541439056396},{\"color\":{\"r\":1.0,\"g\":0.90980392694473267,\"b\":0.27450981736183167,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.96862745285034180,\"g\":0.69411766529083252,\"b\":0.17254902422428131,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.82745099067687988,\"b\":0.11372549086809158,\"a\":1.0},\"position\":0.80885541439056396},{\"color\":{\"r\":1.0,\"g\":0.90980392694473267,\"b\":0.27450981736183167,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":60.384239196777344,\"m01\":60.384243011474609,\"m02\":-14.850948333740234,\"m10\":-60.384243011474609,\"m11\":60.384243011474609,\"m12\":46.558074951171875},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    stroke: "#F7F2F2",
    strokeWidth: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4120_17812)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_diamond_4120_17812_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.48033e-09 0.043 -0.0426981 -1.71075e-09 47.5 45.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.888,
    height: 729.086,
    fill: "url(#paint4_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.888,
    height: 729.086,
    transform: "scale(1 -1)",
    fill: "url(#paint4_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.888,
    height: 729.086,
    transform: "scale(-1 1)",
    fill: "url(#paint4_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.888,
    height: 729.086,
    transform: "scale(-1)",
    fill: "url(#paint4_diamond_4120_17812)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M76.6016 46.23L50.599 49.1071C50.1332 49.1587 49.7657 49.5268 49.7148 49.9926L46.8573 76.1846L43.9997 49.9926C43.9489 49.5267 43.5814 49.1587 43.1156 49.1071L17.113 46.23L43.1156 43.3528C43.5814 43.3013 43.9489 42.9332 43.9997 42.4674L46.8573 16.2754L49.7148 42.4674C49.7657 42.9332 50.1332 43.3013 50.599 43.3528L76.6016 46.23Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99411761760711670,\"g\":0.86862742900848389,\"b\":0.19411765038967133,\"a\":1.0},\"position\":0.095572277903556824},{\"color\":{\"r\":0.98823529481887817,\"g\":0.82745099067687988,\"b\":0.11372549086809158,\"a\":1.0},\"position\":0.19114455580711365},{\"color\":{\"r\":0.96862745285034180,\"g\":0.69411766529083252,\"b\":0.17254902422428131,\"a\":1.0},\"position\":0.40547075867652893}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99411761760711670,\"g\":0.86862742900848389,\"b\":0.19411765038967133,\"a\":1.0},\"position\":0.095572277903556824},{\"color\":{\"r\":0.98823529481887817,\"g\":0.82745099067687988,\"b\":0.11372549086809158,\"a\":1.0},\"position\":0.19114455580711365},{\"color\":{\"r\":0.96862745285034180,\"g\":0.69411766529083252,\"b\":0.17254902422428131,\"a\":1.0},\"position\":0.40547075867652893}],\"transform\":{\"m00\":-2.9606524094560882e-06,\"m01\":-85.396217346191406,\"m02\":90.198104858398438,\"m10\":86.000007629394531,\"m11\":-3.4215061077702558e-06,\"m12\":2.4999983310699463},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4120_17812",
    x: 10.6646,
    y: 9.66602,
    width: 72.3862,
    height: 73.1299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_4120_17812"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4120_17812",
    x: 30.8947,
    y: 17.8947,
    width: 31.2106,
    height: 55.2106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.05266,
    result: "effect1_foregroundBlur_4120_17812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_diamond_4120_17812_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.469 42.3754L46.5001 42.3996L46.5319 42.3748L67.2078 25.7923L50.6254 46.4682L50.6005 46.5L50.6254 46.5318L67.2078 67.2077L46.5319 50.6252L46.5001 50.6004L46.469 50.6246L25.7924 67.2077L42.3756 46.5311L42.3997 46.5L42.3756 46.4689L25.7924 25.7923L46.469 42.3754Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4120_17812",
    x: 17.1128,
    y: 16.2754,
    width: 59.4888,
    height: 59.9092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.278431 0 0 0 0 0.0705882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4120_17812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_diamond_4120_17812_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6016 46.23L50.599 49.1071C50.1332 49.1587 49.7657 49.5268 49.7148 49.9926L46.8573 76.1846L43.9997 49.9926C43.9489 49.5267 43.5814 49.1587 43.1156 49.1071L17.113 46.23L43.1156 43.3528C43.5814 43.3013 43.9489 42.9332 43.9997 42.4674L46.8573 16.2754L49.7148 42.4674C49.7657 42.9332 50.1332 43.3013 50.599 43.3528L76.6016 46.23Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4120_17812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.27297 3.993 -1.53577 16.3097 47.727 46.2343)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4120_17812",
    x1: 47.3683,
    y1: 47.3827,
    x2: 54.9903,
    y2: 39.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191145,
    stopColor: "#FCD31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382289,
    stopColor: "#F7B12C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4120_17812",
    x1: 45.5136,
    y1: 46.2198,
    x2: 45.5136,
    y2: 58.0429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191145,
    stopColor: "#FCD31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382289,
    stopColor: "#F7B12C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_diamond_4120_17812",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B12C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808855,
    stopColor: "#FCD31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_diamond_4120_17812",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955723,
    stopColor: "#FEDE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191145,
    stopColor: "#FCD31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405471,
    stopColor: "#F7B12C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarshine);
export default __webpack_public_path__ + "static/media/star shine.cd994823c520845001f86e786dc5bd1c.svg";
export { ForwardRef as ReactComponent };